import { shallowEqual, useSelector } from 'react-redux'

import { IApplicationState } from '@store'
import { selectSubmission } from '@store/submissions'
import Theme from '@theme'
import { Container } from '@tribegroup'
import { TextContent, TextContentWrapper, TextThumbnailContainer } from './TextPreview.style'

type TextThumbnailPreviewProps = {
  useContainerHeight?: boolean
  content: string
}

export const TextThumbnailPreview: React.FC<TextThumbnailPreviewProps> = ({
  content,
  useContainerHeight,
}) => (
  <TextThumbnailContainer useParentHeight={useContainerHeight}>
    <Container
      absolute
      leftPosition={0}
      topPosition={0}
      height="100%"
      width="100%"
      flexStart
      borderBox
      backgroundColor={Theme.grey200Color}
    >
      <TextContent>
        <TextContentWrapper>{content}</TextContentWrapper>
      </TextContent>
    </Container>
  </TextThumbnailContainer>
)

type Props = {
  submissionId: number
  useContainerHeight?: boolean
}

export const SubmissionCardTextPreview: React.FC<Props> = ({
  submissionId,
  useContainerHeight,
}) => {
  const { caption } = useSelector((state: IApplicationState) => ({
    caption: selectSubmission(state, submissionId)?.text,
  }), shallowEqual)
  return <TextThumbnailPreview content={caption!} useContainerHeight={useContainerHeight} />
}
